import styled from "styled-components";

export const MainSection = styled.section`
  overflow: hidden;

  .container {
    margin-top: 0rem;
    padding-bottom: 4rem;
  }

  background: #fff;
  .data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .btn-div {
    margin-top: 4rem;
  }
`;

export const Title = styled.h5`
  font-size: 3.125rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  text-align: center;
  /* background: linear-gradient(#008bda, #a100d5);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text; */
  color: #032b88;
  text-fill-color: transparent;
  padding-bottom: 5rem;
  padding-top: 6rem;
`;

export const Imgwrapper = styled.div`
  img {
    width: 100%;
  }
`;

export const TokenTitle = styled.h5`
  color: #032b88;
  font-size: 1.9375rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  padding-bottom: 1rem;
  @media (max-width: 990px) {
    margin-top: 3rem;
  }
`;

export const Text = styled.div`
  color: #032b88;
  font-size: 1.375rem;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-transform: capitalize;
  position: relative;

  /* ::before {
    content: "";
    position: absolute;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    height: 1px;
    width: 100px;
    background-color: black;
  } */
`;

export const GitBookBtn = styled.button`
  --border: 5px;
  --slant: 0.7em;
  --color: #032b88;
  font-family: "Catamaran";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  padding: 0.2em 2em;
  border: none;

  margin-top: 4rem;
  cursor: pointer;
  color: #fff;
  background: linear-gradient(90.41deg, #032b88 0.34%, #032b88 99.15%);
  background-repeat: no-repeat;
  box-shadow: 0 0 0 200px inset var(--s, #0000),
    0 0 0 var(--border) inset var(--color);
  clip-path: polygon(
    0 0,
    calc(100% - var(--slant)) 0,
    100% var(--slant),
    100% 100%,
    var(--slant) 100%,
    0 calc(100% - var(--slant))
  );
  transition: color var(--t, 0.3s), background-size 0.3s;

  &:focus-visible {
    outline-offset: calc(-1 * var(--border));
    outline: var(--border) solid #000c;
    clip-path: none;
    background-size: 0 0;
  }

  @media (max-width: 990px) {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 3rem;
  }
`;
